





































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import UserInfoBase from './UserInfoBase.vue'

@Component({
  components: {
    UserInfoBase,
  },
})
export default class UserInfoPc extends Vue {
  @Prop({ required: true })
  carat: string
}
